import { Avatar as AvatarComponent, ImageListViewer } from 'components';
import DefaultLink from 'components/Link';
import { Image } from 'components/MediaListViewer/styles';
import RichText from 'components/RichText';
import { BadgeContainer } from 'components/SWDTeamOrPremiumBadge/styles';
import styled, { css } from 'styled-components';
import { from } from 'styles/mixins';
import { addAlpha } from 'utils/addAlpha';

export const Container = styled.li`
  color: ${({ theme }) => theme.colors.black};
`;

export const Body = styled.div`
  display: grid;
  grid-column-gap: 0.75rem;
  grid-template-columns: 2.5rem auto;
`;

export const DotSeparator = styled.span`
  color: ${({ theme }) => addAlpha(theme.colors.grey400, 0.5)};
  margin: 0 ${({ theme }) => theme.spacing.sm};
  display: none;

  ${from.mobileXL`
    display: inline;
  `}
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;

  ${from.mobileXL`
    flex-direction: row;
  `}
`;

export const Avatar = styled(AvatarComponent)`
  box-sizing: border-box;
  display: block;
  height: 2.5rem;
  width: 2.5rem;
  margin-right: 0;

  ${BadgeContainer} {
    bottom: -0.175rem;
  }
`;

export const Name = styled(DefaultLink)`
  color: ${({ theme }) => theme.colors.accent};
  font-weight: ${({ theme }) => theme.weights.semiBold};
  margin-bottom: 0.3rem;

  :hover:not(:disabled) {
    text-decoration: underline;
  }

  ${from.mobileXL`
    margin-bottom: 0;
`}
`;

export const Info = styled.span`
  color: ${({ theme }) => addAlpha(theme.colors.grey400, 0.5)};
`;

export const SidebarColumn = styled.div`
  display: flex;
  justify-content: center;
`;

export const ContentColumn = styled.div``;

export const ContentRow = styled.div`
  display: block;
  padding: 1rem 0;

  > *:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.md};
    margin-right: 0;
  }

  ${from.tablet`

    > *:not(:last-child) {
      margin-bottom: 0;
      margin-right: ${({ theme }) => theme.spacing.lg};
    }
  `};
`;

export const Content = styled(RichText)`
  line-height: 1.5rem;

  * {
    word-break: break-word;
    hyphens: auto;
  }

  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

export const Replies = styled.div`
  margin-top: ${({ theme }) => theme.spacing.xlg};

  > *:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.xlg};
  }

  grid-column: 2/3;
`;

export const CommentData = styled.div<{
  isAuthorSpotligthAuthor: boolean;
}>`
  border-left: 0.125rem solid ${({ theme }) => theme.colors.grey200};
  display: flex;
  flex-direction: column;
  padding-left: 1rem;
  ${({ isAuthorSpotligthAuthor }) =>
    isAuthorSpotligthAuthor &&
    css`
      border-left: 0.125rem solid ${({ theme }) => theme.colors.accent};
    `}
`;

export const CommentImage = styled(ImageListViewer)`
  border-radius: 0.25rem;
  border: solid 1px ${({ theme }) => addAlpha(theme.colors.grey400, 0.7)};
  min-width: 18rem;
  max-width: 18rem;
  float: left;
  box-sizing: border-box;
  object-fit: cover;
  width: 100%;
  ${Image} {
    max-height: 12rem;
  }

  ${from.mobileXL`
    width: 18rem;
    max-width: 100%;
  `}
`;

export const CommentVideo = styled.video`
  border-radius: 0.25rem;
  border: solid 1px ${({ theme }) => addAlpha(theme.colors.grey400, 0.7)};
  min-width: 18rem;
  max-width: 18rem;
  float: left;
  box-sizing: border-box;
  object-fit: cover;
  width: 100%;
  ${Image} {
    max-height: 12rem;
  }

  ${from.mobileXL`
    width: 18rem;
    max-width: 100%;
  `}
`;
